/* Roo Roo - phone menu drawer. Pairs with roo-nav.css and sections/header.liquid.
   Opens from the left, tracks a sideways swipe 1:1, and on release decides
   open/close from where the flick was heading (velocity projection), not just
   where the finger stopped. Any open/close can be interrupted mid-flight. */
(function () {
  var drawer = document.getElementById('RooDrawer');
  if (!drawer) return;
  var panel = drawer.querySelector('.roo-drawer__panel');
  var scrim = drawer.querySelector('.roo-drawer__scrim');
  var openers = document.querySelectorAll('[data-roo-drawer-open]');
  var root = document.documentElement;
  var lastFocus = null;

  function isOpen() { return drawer.classList.contains('is-open'); }

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.getClientRects().length > 0; }
    );
  }

  function setExpanded(v) {
    for (var i = 0; i < openers.length; i++) openers[i].setAttribute('aria-expanded', v ? 'true' : 'false');
  }

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    root.classList.add('roo-drawer-lock');
    setExpanded(true);
    // Focus the panel itself so a screen reader lands in the menu without a focus ring on the X.
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 30);
  }

  function close(restoreFocus) {
    if (!isOpen()) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    root.classList.remove('roo-drawer-lock');
    setExpanded(false);
    panel.style.transform = '';
    scrim.style.opacity = '';
    if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  window.Roo = window.Roo || {};
  window.Roo.menu = { open: open, close: close, isOpen: isOpen };

  // Press feedback is the :active scale in CSS; the open itself runs on click so
  // keyboard, touch and mouse all behave the same.
  Array.prototype.forEach.call(openers, function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      isOpen() ? close() : open();
    });
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-roo-drawer-close]')) { close(); return; }
    var toggle = e.target.closest('.roo-drawer__toggle');
    if (toggle) {
      var sub = document.getElementById(toggle.getAttribute('aria-controls'));
      var on = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (sub) sub.classList.toggle('is-open', on);
      return;
    }
    var link = e.target.closest('a[href]');
    if (link && link.target !== '_blank') close(false);
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  var mq = window.matchMedia('(min-width: 901px)');
  var onMq = function (m) { if (m.matches) close(false); };
  mq.addEventListener ? mq.addEventListener('change', onMq) : mq.addListener(onMq);

  // Coming back via the browser Back button should never show a stale open drawer.
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(false); });

  // ---- swipe to close ---------------------------------------------------
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var drag = null;

  function rubberband(x, dim) { var c = 0.55; return (x * dim * c) / (dim + c * Math.abs(x)); }
  function project(v) { var d = 0.998; return (v / 1000) * d / (1 - d); }

  function start(e, fromScrim) {
    if (!isOpen() || reduce.matches || (e.pointerType === 'mouse' && e.button !== 0)) return;
    if (e.target.closest && e.target.closest('.roo-drawer__cats--scroll')) return; // let the tile row scroll
    drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: 0, locked: false, dead: false,
             w: panel.getBoundingClientRect().width, hist: [], fromScrim: fromScrim };
  }

  function move(e) {
    if (!drag || e.pointerId !== drag.id || drag.dead) return;
    var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
    if (!drag.locked) {
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
      if (Math.abs(dy) > Math.abs(dx)) { drag.dead = true; return; } // it's a scroll
      drag.locked = true;
      drag.x0 = e.clientX; dx = 0; // no jump at the threshold
      drawer.classList.add('is-dragging');
      try { (drag.fromScrim ? scrim : panel).setPointerCapture(e.pointerId); } catch (_) {}
    }
    drag.dx = dx;
    var now = performance.now();
    drag.hist.push({ t: now, x: dx });
    while (drag.hist.length > 2 && now - drag.hist[0].t > 100) drag.hist.shift();
    var x = dx <= 0 ? dx : rubberband(dx, drag.w);
    panel.style.transform = 'translate3d(' + x + 'px,0,0)';
    scrim.style.opacity = String(Math.max(0, Math.min(1, 1 + Math.min(0, dx) / drag.w)));
  }

  function end(e) {
    if (!drag || e.pointerId !== drag.id) return;
    var d = drag; drag = null;
    if (!d.locked) return;
    var h = d.hist, v = 0;
    if (h.length > 1) {
      var a = h[0], b = h[h.length - 1];
      if (b.t > a.t) v = (b.x - a.x) / (b.t - a.t) * 1000; // px/s
    }
    var projected = d.dx + project(v);
    var shouldClose = v < -400 || projected < -d.w / 2;
    // Removing the drag class and the inline transform in the same frame makes the
    // CSS transition start from where the finger let go instead of snapping.
    drawer.classList.remove('is-dragging');
    if (shouldClose) close();
    else { panel.style.transform = ''; scrim.style.opacity = ''; }
    // A swipe must not also count as a tap on whatever was under the finger.
    var swallow = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
    window.addEventListener('click', swallow, { capture: true, once: true });
    setTimeout(function () { window.removeEventListener('click', swallow, { capture: true }); }, 350);
  }

  panel.addEventListener('pointerdown', function (e) { start(e, false); });
  // A mouse drag on a link or photo would start the browser's own drag-and-drop.
  panel.addEventListener('dragstart', function (e) { e.preventDefault(); });
  scrim.addEventListener('pointerdown', function (e) { start(e, true); });
  window.addEventListener('pointermove', move, { passive: true });
  window.addEventListener('pointerup', end);
  window.addEventListener('pointercancel', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var locked = drag.locked; drag = null;
    if (locked) { drawer.classList.remove('is-dragging'); panel.style.transform = ''; scrim.style.opacity = ''; }
  });
})();

/* Search sheet: drops from the top, shows products as you type (Shopify
   predictive search). Stale requests are aborted so results never arrive out of
   order; arrow keys + Enter pick a result. */
(function () {
  var sheet = document.getElementById('RooSearch');
  if (!sheet) return;
  var input = sheet.querySelector('.roo-search__input');
  var form = sheet.querySelector('.roo-search__form');
  var clearBtn = sheet.querySelector('.roo-search__clear');
  var results = document.getElementById('RooSearchResults');
  var root = document.documentElement;
  var lastFocus = null, timer = null, ctrl = null, active = -1, cache = {};
  var searchUrl = form.getAttribute('action') || '/search';

  function isOpen() { return sheet.classList.contains('is-open'); }
  function open() {
    if (isOpen()) return;
    if (window.Roo && window.Roo.menu && window.Roo.menu.isOpen()) window.Roo.menu.close(false);
    lastFocus = document.activeElement;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    root.classList.add('roo-drawer-lock');
    // Focus synchronously inside the tap so iOS raises the keyboard.
    input.focus({ preventScroll: true });
    if (input.value) input.select();
  }
  function close() {
    if (!isOpen()) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    root.classList.remove('roo-drawer-lock');
    input.blur();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.Roo = window.Roo || {};
  window.Roo.search = { open: open, close: close };

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-roo-search-open]');
    if (!t) return;
    e.preventDefault();
    open();
  });
  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-roo-search-close]')) { close(); return; }
    var a = e.target.closest('a[href]');
    if (a) { sheet.classList.remove('is-open'); root.classList.remove('roo-drawer-lock'); }
  });

  function money(amount) {
    var cents = Math.round(parseFloat(amount) * 100);
    if (!isFinite(cents)) return '';
    return window.Roo && window.Roo.formatMoney ? window.Roo.formatMoney(cents) : 'Rs. ' + (cents / 100).toFixed(2);
  }
  function safePath(u) {
    if (!u || typeof u !== 'string') return null;
    if (window.Roo && window.Roo.isSafePath) return window.Roo.isSafePath(u) ? u : null;
    return /^\/[^\/\\]/.test(u) ? u : null;
  }
  function safeImg(u) {
    if (!u || typeof u !== 'string') return null;
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return /^https:\/\/[^\/]*(shopify\.com|shopifycdn\.net|itsrooroo\.com)\//.test(u) ? u : null;
  }
  function sized(u, w) { return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function allLink(q) { return searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }

  function render(q, products) {
    results.textContent = '';
    active = -1;
    if (!products.length) {
      results.appendChild(el('p', 'roo-search__empty', 'Nothing matched “' + q + '”. Try a shorter word, or browse below.'));
      sheet.classList.remove('has-query');
      return;
    }
    var list = el('ul', 'roo-search__list');
    list.setAttribute('role', 'listbox');
    products.forEach(function (p, i) {
      var href = safePath(p.url);
      if (!href) return;
      var li = el('li', 'roo-search__item');
      li.setAttribute('role', 'option');
      li.id = 'RooSearchOpt' + i;
      var a = el('a');
      a.href = href;
      var th = el('span', 'roo-search__thumb');
      var src = safeImg((p.featured_image && p.featured_image.url) || p.image);
      if (src) {
        var img = el('img');
        img.src = sized(src, 120);
        img.alt = '';
        img.loading = 'lazy';
        img.width = 52; img.height = 66;
        th.appendChild(img);
      }
      var meta = el('span', 'roo-search__meta');
      meta.appendChild(el('span', 'roo-search__title', (window.Roo && window.Roo.safeText) ? window.Roo.safeText(p.title, 140) : String(p.title || '')));
      var price = el('span', 'roo-search__price', money(p.price));
      var cmp = parseFloat(p.compare_at_price_max);
      if (cmp && cmp > parseFloat(p.price)) price.appendChild(el('s', null, money(cmp)));
      if (p.available === false) price.appendChild(el('span', 'roo-search__soldout', 'Sold out'));
      meta.appendChild(price);
      a.appendChild(th); a.appendChild(meta); li.appendChild(a); list.appendChild(li);
    });
    results.appendChild(list);
    var all = el('a', 'roo-search__all', 'See all results for “' + q + '”');
    all.href = allLink(q);
    results.appendChild(all);
  }

  function run() {
    var q = input.value.trim();
    clearBtn.hidden = !input.value;
    sheet.classList.toggle('has-query', !!q);
    if (ctrl) { ctrl.abort(); ctrl = null; }
    if (!q) { results.textContent = ''; results.classList.remove('is-loading'); return; }
    if (cache[q]) { render(q, cache[q]); return; }
    results.classList.add('is-loading');
    ctrl = window.AbortController ? new AbortController() : null;
    var url = searchUrl.replace(/\/$/, '') + '/suggest.json?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last';
    fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        cache[q] = prods;
        if (input.value.trim() === q) { results.classList.remove('is-loading'); render(q, prods); }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        results.classList.remove('is-loading');
        results.textContent = '';
        var a = el('a', 'roo-search__all', 'Search for “' + q + '”');
        a.href = allLink(q);
        results.appendChild(a);
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    clearBtn.hidden = !input.value;
    timer = setTimeout(run, 120);
  });
  clearBtn.addEventListener('click', function () { input.value = ''; run(); input.focus(); });

  function setActive(i) {
    var items = results.querySelectorAll('.roo-search__item');
    if (!items.length) return;
    active = (i + items.length) % items.length;
    for (var k = 0; k < items.length; k++) items[k].classList.toggle('is-active', k === active);
    input.setAttribute('aria-activedescendant', items[active].id);
    items[active].scrollIntoView({ block: 'nearest' });
  }
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
  });
  form.addEventListener('submit', function (e) {
    var items = results.querySelectorAll('.roo-search__item a');
    if (active >= 0 && items[active]) { e.preventDefault(); window.location.href = items[active].href; return; }
    if (!input.value.trim()) { e.preventDefault(); return; }
    e.preventDefault();
    window.location.href = allLink(input.value.trim());
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(sheet.querySelectorAll('a[href], button:not([hidden]), input'), function (n) { return n.getClientRects().length; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true'); root.classList.remove('roo-drawer-lock'); }
  });
})();
